import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArticleList from '../article-list';

class Sidebar extends Component {
  render() {
    const { classes } = this.props;


    const articleCounts = this.props.orders
      .flatMap(o => o.articles)
      .reduce((accumulator, current) => {
        const currentValue = accumulator[current.name] || 0;
        // eslint-disable-next-line no-param-reassign
        accumulator[current.name] = currentValue + current.quantity;
        return accumulator;
      }, {});

    const articles = Object.keys(articleCounts).map(k => ({
      name: k,
      quantity: articleCounts[k],
    }));

    return (
      <div className={classes.root}>
        <ArticleList value={articles} />
      </div>
    );
  }
}

const styles = () => ({
  root: {
  },
});

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array.isRequired,
};


export default withStyles(styles)(Sidebar);
